import React, { useState, useRef, useEffect } from "react";
import styles from "./SelectService.module.css";
import beauty from "../../assets/beauty.png";
import bathroom from "../../assets/bathroom.png";
import clean from "../../assets/HomeClean.png";
import wash from "../../assets/washing.png";
import ProductList from "../ProductList/ProductList";
import { Button } from "react-bootstrap";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
const services = [
  { id: 1, name: "Home Clean", img: clean },
  { id: 2, name: "Beauty Services", img: beauty },
  { id: 3, name: "Flat Cleaning", img: bathroom },
  { id: 4, name: "Appliances Services", img: wash },
  { id: 5, name: "Beauty Services", img: beauty },
  { id: 6, name: "Flat Cleaning", img: bathroom },
];

export default function SelectService({ subcategory }) {
  const [selectedServices, setSelectedServices] = useState(subcategory[0].title);
  const [serviceData, setServiceData] = useState(subcategory[0].services);
   console.log("subcategor",subcategory)
  const toggleService = (service) => {
    setSelectedServices(service);
  };

  const box1Ref = useRef(null);
  const box2Ref = useRef(null);
  const [box1Locked, setBox1Locked] = useState(false);

  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 200; // adjust for speed
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Select Services</h2>
      {/* <ul className={`${styles.serviceList} ${styles.horizontalScroll}`}>
      {services.map((service) => {
       

        return (
          <li
            key={service.id}
            className={`${styles.serviceItem} ${selectedServices === service.id ? styles.selectedRed : ''}`}
            onClick={() => toggleService(service.id)}
          >
           <img src={service.img} className={styles.selectBoxImg} />
           <p className={styles.selectboxText}>{service.name}</p>
           
          </li>
        );
      })}
    </ul> */}
      <div className={styles.sliderRow}>
        <div style={{ width: "90%", position: "relative" }}>
          {/* Left Arrow */}
          <Button
            style={{
              position: "absolute",
              top: "40%",
              left: "-30px",
              transform: "translateY(-50%)",
              cursor: "pointer",
              zIndex: 1,
              borderRadius: 100,
            }}
            onClick={() => scroll("left")}
            size="sm"
            variant="outline-primary"
          >
            <FiChevronLeft style={{ marginTop: -5 }} />
          </Button>
          {/* Scrollable Service List */}
          <div
            className={styles.serviceList}
            ref={scrollRef}
            style={{
              display: "flex",
              overflowX: "auto",
              scrollBehavior: "smooth",
              gap: "10px",
            }}
          >
            {subcategory.map((service) => (
              <div
                key={service.id}
                className={`${styles.serviceItem} ${
                  selectedServices === service.title ? styles.selectedRed : ""
                }`}
                onClick={() => {toggleService(service.title); setServiceData(service.services);}}
>
                <img src={service.img} className={styles.selectBoxImg} />
                <p className={styles.selectboxText}>{service.title}</p>
              </div>
            ))}
          </div>

          {/* Right Arrow */}
          <Button
            style={{
              position: "absolute",
              top: "40%",
              right: "-30px",
              transform: "translateY(-50%)",
              cursor: "pointer",
              zIndex: 1,
              borderRadius: 100,
            }}
            onClick={() => scroll("right")}
            size="sm"
            variant="outline-primary"
          >
            <FiChevronRight style={{ marginTop: -5 }} />
          </Button>
        </div>
      </div>

      <ProductList selectedService={serviceData} />
    </div>
  );
}
